import React from "react";
import useAddRef, { UseAddRefOptions } from "../useAddRef";

interface IntroPageProps extends UseAddRefOptions {}

const IntroPage: React.FC<IntroPageProps> = ({ addRef }) => {
  const ref = useAddRef({ addRef });
  return (
    <div className="eoy-page intro-page" ref={ref}>
      <h1>Looking Back — 2025 Was Incredible!</h1>
      <h2>
        We Collected Highlights on Your Accomplishments This Year with
        Seemplicity
      </h2>
    </div>
  );
};

export default IntroPage;
